interface Properties {
  src?: string;
}

const Avatar: React.FC<Properties> = ({ src }) => (
  <img
    src={src}
    alt="user's avatar"
    // we might consider a proxy image when no image is privided but the current solution is temporary ig
    className="rounded-full bg-red-400 h-11 w-11 text-transparent"
  />
);

export default Avatar;
